module.exports = __webpack_public_path__ + "assets/img/s6.76a40d7d.png";